import React from 'react';
import Button, { ButtonBackgroundType } from '@kvika/button';
import { StyledEntityContainer } from '../styles/SelectEntityStyles';
import EntityInfo from './EntityInfo';
var Entity = function (_a) {
    var entity = _a.entity, selectButtonText = _a.selectButtonText, onEntitySelect = _a.onEntitySelect, ssnText = _a.ssnText, testId = _a.testId;
    var onClick = function () {
        if (onEntitySelect) {
            onEntitySelect(entity);
        }
    };
    return (React.createElement(StyledEntityContainer, { "data-testid": "".concat(testId, "-").concat(entity.ssn, "-entity") },
        React.createElement(EntityInfo, { ssnText: ssnText, entity: entity, testId: testId }),
        React.createElement(Button, { backgroundType: ButtonBackgroundType.Outlined, onClick: onClick, "data-testid": "".concat(testId, "-").concat(entity.ssn, "-button") }, selectButtonText)));
};
export default Entity;
//# sourceMappingURL=Entity.js.map